import { ColorOptions, convertHexToRGBA, MaterialTextInput, Text, TextInputProps } from '@jfs/ui-new'
import { useState } from 'react'
import { Platform } from 'react-native'
interface Props extends TextInputProps {
  setFieldValue: (field: string, value: string | number) => void
  fieldName: string
  testID?: string
  onCustomBlur: (mNumber: string) => void
  theme: any
}

const NumberTextInput = (props: Props) => {
  const { fieldName, setFieldValue = () => {}, testID = '', label = '', error, touched, theme } = props

  const [mobileNumber, setMobileNumber] = useState('')

  const internalOnChangeText = (text: string) => {
    const numberWithoutSpace = text.replace(/[^0-9]/g, '')
    setMobileNumber(numberWithoutSpace)
    setFieldValue(fieldName, numberWithoutSpace)
  }

  return (
    <>
      <MaterialTextInput
        placeholderTextColor={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions}
        color={theme?.bodyTextColor as ColorOptions}
        bottomLineColor={theme?.brandColor as ColorOptions}
        onFocusBottomLineColor={theme?.brandColor as ColorOptions}
        selectionColor={theme?.brandColor as ColorOptions}
        testID={testID}
        label={label}
        value={mobileNumber}
        onChangeText={internalOnChangeText}
        keyboardType={Platform.OS === 'web' ? undefined : 'number-pad'}
        maxLength={10}
        error={error}
        tintColor={theme?.brandColor as ColorOptions}
        leftComponent={
          <Text
            {...{
              color: theme?.bodyTextColor as ColorOptions,
              fontSize: 14,
              fontFamily: 'jiotype-medium',
              fontWeight: '700',
            }}>
            {' '}
            +91
          </Text>
        }
        touched={touched}
        fontSize={14}
        fontFamily="jiotype-medium"
        fontWeight="500"
      />
    </>
  )
}

export { NumberTextInput }
